module.exports = __webpack_public_path__ + "img/img_privacy.1a628f1c.gif";